// src/pages/AdvancedProductPage.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdvancedProductPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/products', { replace: true, state: { openProductCreate: true } });
  }, [navigate]);

  return (
    <div className="p-6">
      <p className="text-sm text-slate-500">Redirecting to Products…</p>
    </div>
  );
}
